import actions from "./actions";

const initState = {
    panelAccessList: [],
    getPanelAccessLoading: false,
    getPanelAccessError: null,

    updatePanelAccessMessage: null,
    updatePanelAccessLoading: false,
    updatePanelAccessError: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.GET_PANEL_ACCESS:
            return {
                ...state,
                getPanelAccessLoading: true,
                getPanelAccessError: null,
                panelAccessList: [],
            };

        case actions.GET_PANEL_ACCESS_SUCCESS:
            return {
                ...state,
                getPanelAccessLoading: false,
                getPanelAccessError: null,
                panelAccessList: action.payload.data,
            };

        case actions.GET_PANEL_ACCESS_FAILED:
            return {
                ...state,
                getPanelAccessLoading: false,
                getPanelAccessError: action.error,
            };

        case actions.UPDATE_PANEL_ACCESS:
            return {
                ...state,
                updatePanelAccessMessage: null,
                updatePanelAccessLoading: true,
                updatePanelAccessError: null,
            };

        case actions.UPDATE_PANEL_ACCESS_SUCCESS:
            return {
                ...state,
                updatePanelAccessLoading: false,
                updatePanelAccessError: null,
                updatePanelAccessMessage: action.payload.message,
            };

        case actions.UPDATE_PANEL_ACCESS_FAILED:
            return {
                ...state,
                updatePanelAccessLoading: false,
                updatePanelAccessError: action.error,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                getPanelAccessError: null,
                panelAccessList: [],
                updatePanelAccessMessage: null,
                updatePanelAccessError: null,
            };

        default:
            return state;
    }
}